import React from 'react';
import { USBButton } from '@usb-shield/forms-beta';
import { Recommendations as RecommendationsComponent } from '@usb-onboarding/product-recommender-components';
import styles from './allproducts.module.scss';

function AllProducts({
    title,
    content,
    recommendations,
    goBack,
    restartRecommender,
    buttonCallback,
}) {
    return (
        <>
            <div className={styles['main-content-wrapper']}>
                <div className={styles['main-left-content']}>
                    <h1 className={styles.title}>{title}</h1>
                    <div
                        className={styles.content}
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                    <div className={styles.recommendations}>
                        <RecommendationsComponent
                            buttonCallback={buttonCallback}
                            recommendations={recommendations}
                        />
                    </div>
                    <div className={styles['results-footer']}>
                        <div className={styles['button-container']}>
                            <USBButton
                                variant="text"
                                ariaLabel="Return to previous page"
                                onSubmit={goBack}
                            >
                                Back
                            </USBButton>

                            <USBButton
                                variant="secondary"
                                ariaLabel="Start questionnaire"
                                onSubmit={restartRecommender}
                            >
                                Restart Recommender
                            </USBButton>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AllProducts;
